<div class="wait-indicator" *ngIf="dataSource && dataSource.loading">
    <mat-spinner></mat-spinner>
</div>
<div class="">
    <!-- ADD EVENT BUTTON -->
    <button *ngIf="showAddButton" mat-fab class="add-event-button mat-warn" (click)="addNewClicked()" aria-label="Add event" [@animate]="{value:'*',params:{delay:'300ms',scale:'0.2'}}">
        <mat-icon class="icon">add</mat-icon>
    </button>
    <!-- / ADD EVENT BUTTON -->

    <mat-table *ngIf="fields && fields.length > 0" class="entities-table" [dataSource]="dataSource" matSort [@animateStagger]="{value:'50'}" wtfPerfectScrollbar>
        <!-- Columns Definitions -->
        <ng-container *ngFor="let field of fields" cdkColumnDef="{{field}}">
            <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{captions[field]}}</mat-header-cell>
            <mat-cell *matCellDef="let row">
                <ng-container *ngIf="columnTypes[field]===0">
                    <p class="text-truncate">{{row[field]}}</p>
                </ng-container>

                <ng-container *ngIf="columnTypes[field]===1">
                    <mat-form-field class="w-100-p">
                        <input matInput placeholder="" type="number" value="{{row[field]}}" (change)="processValueChanged(row, field, $event)">
                    </mat-form-field>
                </ng-container>

                <ng-container *ngIf="columnTypes[field]===2">
                    <mat-slide-toggle class="mr-24" aria-label="Active" [checked]="ConvertBoolean(row[field])" (change)="changeBoolean(row, field, $event)">
                        {{row[field] ? 'Activo' : 'Inactivo'}}
                    </mat-slide-toggle>
                </ng-container>

                <ng-container *ngIf="columnTypes[field]===3">
                 <!--   <secured-image class="avatar"  *ngIf="row[field]" [src]="row[field]"></secured-image> -->
                    <img class="avatar"  *ngIf="!row[field]" src="/src/assets/images/ecommerce/product-image-placeholder.png">
                </ng-container>

                <ng-container *ngIf="columnTypes[field]===4">
                    <p class="w-50-p" class="text-truncate">{{ row[field] | dateFormat}}</p>
                </ng-container>
            </mat-cell>
        </ng-container>

        <!-- Buttons Column -->
        <ng-container cdkColumnDef="buttons">
            <mat-header-cell *cdkHeaderCellDef></mat-header-cell>
            <mat-cell *cdkCellDef="let entity">
                <div fxFlex="row" fxLayoutAlign="end center">
                    <button *ngFor="let action of actions" mat-icon-button (click)="$event.stopPropagation();performAction(action, entity)">
                        <mat-icon>{{action.iconName}}</mat-icon>
                    </button>
                </div>
            </mat-cell>
        </ng-container>

        <mat-header-row *cdkHeaderRowDef="fields"></mat-header-row>

        <mat-row *cdkRowDef="let entity; columns: columnsToShow;" [ngClass]="{'mat-light-blue-50-bg':entity == selectedRecord}" (click)="performRowClick(entity)" (dblclick)="performRowDoubleClick(entity)">
        </mat-row>
    </mat-table>

    <mat-paginator #paginator *ngIf="!hidePaginator" [length]="dataSource.totalNumberOfRecords" [pageIndex]="0" [pageSize]="10" (page)="performPagination($event)">
        <!--[pageSizeOptions]="[5, 10, 25, 100]"-->
    </mat-paginator>
</div>

<!-- <div id="table-message" fxLayout="column" fusePerfectScrollbar *ngIf="emptyTable">
    <div id="table-message-form-wrapper" fxLayout="column" fxLayoutAlign="center center">
        <div id="table-message-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">
            <div class="top">
                <div class="logo">
                    <img src="../../../../assets/images/emptybox.png">
                </div>
                <div class="title">No Records to Display!</div>
                <div class="subtitle">There are not records to display at this moment.
                </div>
            </div>
        </div>
    </div>
</div> -->
